import { UserRole } from 'common';

export type AuthRole = UserRole | undefined;

export function isAdminRole(role: AuthRole): boolean {
  return role === 'admin';
}

export function canAccessDayOverview(role: AuthRole): boolean {
  return role === 'admin' || role === 'moderator';
}
